export enum ChangeLogColumns {
    LIST_ID = "listId",
    LIST_NAME = "listName",
    DATE_CHANGED = "date",
    CHANGE_TYPE = "changeType",
    PREVIOUS_VALUE = "previousValue",
    CURRENT_VALUE = "currentValue",
}
